// extracted by mini-css-extract-plugin
module.exports = {"icon":"FileImage_icon__2_6jn","image":"FileImage_image__B1mgc"};